import { render, staticRenderFns } from "./chartBiofeedback.vue?vue&type=template&id=45a93e39"
import script from "./chartBiofeedback.vue?vue&type=script&lang=js"
export * from "./chartBiofeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports